import React from "react"
import TextInput from "../../../components/InputBoxes/TextInput"

const LoginPhoneNumberSection = ({
  onChange,
  value = "",
  onClick,
  visible = false,
}) => {
  return (
    <div
      className={`sliding-panel flex flex-col  ${visible ? "" : "slideData"}`}
    >
      {visible ? (
        <>
         <p className="font-filson-soft font-[700] text-[32px] mt-[18px]">
                Fast, Simple, Secure
              </p>
          <p className="text-[#424952D9] font-[400] text-[14px] leading-[22px]  mb-[45px]">
            Kick off your Fastfin experience.
          </p>
          <TextInput
            value={value}
            type="text"
            onChange={onChange}
            placeholder="Email or phone number"
            className="max-w-[526px] w-[80dvw] border-0"
            name="email"
          />
          <div className="flexRow mt-[15px] items-start">
            {/* <input
              type="checkbox"
              style={{
                border: "1px solid #000000",
                padding: "10px",
                borderRadius: "5px",
                marginTop: "5px",
              }}
              className=""
              onClick={onClick}
            /> */}
            <p className="text-[#424952D9] font-[400] text-[14px] leading-[22px">
              By clicking Continue, you agree to FastFin’s
              <br />
              <a href="/terms" className="underline text-[#04B085]">
                {" "}
                Terms & Conditions
              </a>{" "}
              &{" "}
              <a href="/privacy" className="underline text-[#04B085]">
                {" "}
                Privacy Policy
              </a>
            </p>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  )
}

export default LoginPhoneNumberSection
